import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../styles/styles.css';
import { TextField, Button, Container, Typography, Box, Checkbox, FormControlLabel, Link, Alert, CircularProgress } from '@mui/material';
import authService from '../../services/authService';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await authService.login(email, password);
      // Siempre guardamos los datos del usuario
      localStorage.setItem('user', JSON.stringify({ email, ...response }));
      navigate('/dashboard', { replace: true });
    } catch (err) {
      setError(err.message || 'Error al iniciar sesión');
    } finally {
      setLoading(false);
    }
  };

  const handleReset = () => {
    setEmail('');
    setPassword('');
    setRememberMe(false);
    setError('');
  };

  return (
    <div className="background">
      <Container className="demo">
        <header>
          <Typography variant="h4">Iniciar Sesión</Typography>
        </header>
        <form onSubmit={handleSubmit}>
          {error && (
            <Box mb={2}>
              <Alert severity="error">{error}</Alert>
            </Box>
          )}
          <Box mb={2}>
            <TextField
              label="Correo electrónico"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder=""
              fullWidth
              required
              InputProps={{
                startAdornment: <i className="fas fa-user"></i>,
              }}
            />
          </Box>
          <Box mb={2}>
            <TextField
              label="Contraseña"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder=""
              fullWidth
              required
              InputProps={{
                startAdornment: <i className="fas fa-lock"></i>,
              }}
            />
          </Box>
          <Box mb={2} display="flex" justifyContent="space-between" alignItems="center">
            <FormControlLabel
              control={
                <Checkbox
                  checked={rememberMe}
                  onChange={(e) => setRememberMe(e.target.checked)}
                  name="rememberMe"
                  color="primary"
                />
              }
              label="Recordarme"
            />
            <Link href="#" variant="body2">
              ¿Olvidaste tu contraseña?
            </Link>
          </Box>
          <Box mb={2}>
            <Button 
              type="submit" 
              variant="contained" 
              color="primary" 
              fullWidth 
              disabled={loading}
            >
              {loading ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                'Iniciar Sesión'
              )}
            </Button>
          </Box>
          <Typography variant="body2" align="center">
            ¿No tienes una cuenta? <Link href="#">Regístrate</Link>
          </Typography>
        </form>
      </Container>
    </div>
  );
};

export default Login;